module.exports = __webpack_public_path__ + "img/super-hero-1.2018c2bb.png";